import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import { Toast } from 'primereact/toast';

import api from '../api/api';

import { Dialog } from 'primereact/dialog';
import { AuthContext } from '../contexts/AuthContext';
import { FilterContext } from '../contexts/FilterContext';
import { BrCalendar } from './BrCalendar';
import { DialogPrecosHome } from '../components/DialogPrecosHome';

export const TabelaPrecosHome = () => {

    const confirmationToast = useRef(null);
    const toast = useRef(null);
    const [dt, setDt] = useState(null);
    const [precos, setPrecos] = useState([]);
    const [precosImpressao, setPrecosImpressao] = useState([]);
    const [produtosOptions, setProdutosOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('produtoGrupoNome');
    const [showListaPrecos, setShowListaPrecos] = useState(false);
    const [isShowInfo, setIsShowInfo] = useState(false);
    const [msgInfo, setMsgInfo] = useState([]);
    const [rows, setRows] = useState(20);
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedDataCotacao, setSelectedDataCotacao] = useState(null);
    const { filter, setFilter } = useContext(FilterContext);

    useEffect(() => {
        handleLimparClick();
        return () => {
            setProdutosOptions([])
        }

    }, [])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Cotação de Preços</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => handleLimparClick()}
                    />
                </div>
            </div>
        </div>

    );


    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
                'valorMinimo': { value: null, matchMode: 'contains' },
                'valorMedio': { value: null, matchMode: 'contains' },
                'valorMaximo': { value: null, matchMode: 'contains' },
                'precoData': { value: '', matchMode: 'equals' },
                'produtoGrupoId': { value: null, matchMode: 'equals' },
                'produtoGrupoNome': { value: '', matchMode: 'equals' },
            },

        });
        setSelectedStatus(null);
        setSelectedDataCotacao(null);
    }

    const getPrecos = useCallback(async (event) => {
        setIsLoading(true);
        setPrecos([]);

        let paginaAtual = 0;
        if (event !== undefined) {
            const startIndex = event.first;
            setFirst(startIndex);
            paginaAtual = event.first / event.rows;
        }

        try {
            let pesquisa = {
                "valorMinimo": filter.filters?.valorMinimo?.value || null,
                "valorMedio": filter.filters?.valorMedio?.value || null,
                "valorMaximo": filter.filters?.valorMaximo?.value || null,
                "produtoGrupoId": filter.filters?.produtoGrupoId?.value || null,
                "produtoGrupoNome": filter.filters?.produtoGrupoNome?.value || "",
                "precoData": filter.filters?.precoData?.value || '',
            };

            const respElements = await api.post(
                `precos/searchPrecosHome/${sortableCampo}/${sortable}?page=${paginaAtual}&size=${rows}`,
                pesquisa
            );
            
            setPrecos(respElements.data.content);
            setTotalRecords(respElements.data.totalElements);
        } catch (error) {
            console.error("Erro na requisição:", error);
        }

        setIsLoading(false);
    }, [filter, sortable, sortableCampo, rows]);


    useEffect(() => {
        const fetchPrecos = async () => {
            try {
                await getPrecos();
            } catch (error) {
                toast.current.show({ severity: "error", summary: "Erro ", detail: error.toString() });
            }
        };
        fetchPrecos();

    }, [getPrecos]);

    const produtoNomeBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Produto</span>
                    <span className="table-data">{rowData.produtoGrupoNome != undefined ? rowData.produtoGrupoNome : rowData[0].produtoGrupoNome}</span>
                </p>
            </React.Fragment>
        );
    }

    const produtoUnBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Un Padrão</span>
                    <span className="table-data">{rowData.produtoGrupoUn != undefined ? rowData.produtoGrupoUn : rowData[0].produtoGrupoUn}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorMedioBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Valor Médio</span>
                    <span className="table-data">R$ {rowData.valorMedio != undefined ? rowData.valorMedio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : rowData[0].valorMedio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorMinimoTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Valor Mínimo</span>
                    <span className="table-data">R$ {rowData.valorMinimo != undefined ? rowData.valorMinimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : rowData[0].valorMinimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorMaximoTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Valor Mínimo</span>
                    <span className="table-data">R$ {rowData.valorMaximo != undefined ? rowData.valorMaximo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : rowData[0].valorMaximo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </p>
            </React.Fragment>
        );
    }

    const precoDataBodyTemplate = (rowData) => {
        const date = new Date(rowData.precoData + "T03:00:00Z");
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Data Cotação</span>
                    <span className="table-data">{date.toLocaleDateString()}</span>
                </p>
            </React.Fragment>
        )
    }

    const handlePrintClick = async () => {

        let filtroNome = filter.filters.produtoGrupoNome

        if (filtroNome === undefined || filtroNome.value === '') {
            let pesquisa = {
                "valorMinimo": filter.filters?.valorMinimo?.value || null,
                "valorMedio": filter.filters?.valorMedio?.value || null,
                "valorMaximo": filter.filters?.valorMaximo?.value || null,
                "produtoGrupoId": filter.filters?.produtoGrupoId?.value || null,
                "produtoGrupoNome": filter.filters?.produtoGrupoNome?.value || "",
                "precoData": filter.filters?.precoData?.value || '',
            };

            const respElements = await api.post(
                `precos/searchPrecosHome/${sortableCampo}/${sortable}?page=0&size=1000`,
                pesquisa
            );            
            setPrecosImpressao(respElements.data.content);
        }
        setShowListaPrecos(true);
    };

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable == 'ASC') {
            setSortable('DESC')
        } else if (sortable == 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setFilter(event);
    }

    const onDataCotacaoSearchChange = (event) => {
        if (event.value !== null) {
            let data = new Date(event.value).toISOString();
            dt.filter(data, 'precoData', 'equals');
            setSelectedDataCotacao(event.value);
        }
        else
            dt.filter(null, 'precoData', 'equals');
    }

    const onDataCotacaoInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'precoData', 'equals');
            setSelectedDataCotacao(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'precoData', 'equals');
    }    


    return (
        <>
            <Dialog className='p-scrollpanel-bar-y' header="Histórico" onHide={() => setIsShowInfo(false)} visible={isShowInfo} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '50vw', heigth: '5vw' }} >
                {msgInfo.map((item) => {
                    return (<p><li>{new Date(item.created_at).toLocaleString()} - {item.log}</li></p>)
                })}
            </Dialog>

            <DialogPrecosHome
                visible={showListaPrecos}
                setVisible={setShowListaPrecos}
                preco={precosImpressao}
            />

            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <div className="p-my-0 p-dir-rev p-col">
                    <div className="p-my-0">
                        <Button
                            textAlign="center"
                            icon="pi pi-print"
                            className="p-button-secondary"
                            style={{ width: "35px" }}
                            onClick={handlePrintClick}
                            tooltip="Gerar relatório"
                            tooltipOptions={{ position: "top" }}
                        />
                    </div>
                </div>
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />
                <div className="card p-col-12 datatable-responsive-demo">
                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getPrecos}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={precos}
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhum preço encontrado"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} preços`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={(filter !== null && filter.filters !== undefined) ? filter.filters : {}}
                        >
                            <Column
                                field="produtoGrupoNome"
                                header="Nome"
                                sortable={sortable}
                                body={produtoNomeBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={(filter !== null && filter.filters !== undefined) && (filter.filters.produtoGrupoNome != undefined && filter.filters.produtoGrupoNome.value != '') ? filter.filters.produtoGrupoNome.value : "Pesquisar pelo nome"}
                            />

                            <Column
                                field="produtoGrupoUn"
                                header="Un Padrão"                                
                                body={produtoUnBodyTemplate}                                
                            />

                            <Column
                                field="valorMinimo"
                                header="Valor Mínimo"
                                sortable={sortable}
                                body={valorMinimoTemplate}
                                filterPlaceholder={(filter !== null && filter.filters !== undefined) && (filter.filters.valorMinimo != undefined && filter.filters.valorMinimo.value != '') ? filter.filters.valorMinimo.value : "Pesquisar pelo valor Mínimo"}
                            />

                            <Column
                                field="mediaValor"
                                header="Valor Médio"
                                sortable={sortable}
                                body={valorMedioBodyTemplate}
                                filterPlaceholder={(filter !== null && filter.filters !== undefined) && (filter.filters.mediaValor != undefined && filter.filters.mediaValor.value != '') ? filter.filters.mediaValor.value : "Pesquisar pelo valor Médio"}
                            />

                            <Column
                                field="valorMaximo"
                                header="Valor Máximo"
                                sortable={sortable}
                                body={valorMaximoTemplate}
                                filterPlaceholder={(filter !== null && filter.filters !== undefined) && (filter.filters.valorMaximo != undefined && filter.filters.valorMaximo.value != '') ? filter.filters.valorMaximo.value : "Pesquisar pelo valor máximo"}
                            />

                            <Column
                                field="precoData"
                                header="Data Cotação"
                                sortable
                                body={precoDataBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataCotacao}
                                        id="precoData"
                                        name="precoData"
                                        value={selectedDataCotacao}
                                        onSelect={(e) => onDataCotacaoSearchChange(e)}
                                        onInput={(e) => onDataCotacaoInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 2}`}
                                        placeholder="Selecione uma data"
                                        onClearButtonClick={() => handleLimparClick()}
                                        disabledDays="none"
                                    />
                                }
                            />

                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
}

